/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPiFormDataResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPiFormDataResponse(value) {
    if (!('OrderPublicId' in value) || value['OrderPublicId'] === undefined)
        return false;
    if (!('RedirectUrl' in value) || value['RedirectUrl'] === undefined)
        return false;
    if (!('ProductName' in value) || value['ProductName'] === undefined)
        return false;
    if (!('ProductDescription' in value) || value['ProductDescription'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('ImageUrl' in value) || value['ImageUrl'] === undefined)
        return false;
    if (!('IconUrl' in value) || value['IconUrl'] === undefined)
        return false;
    if (!('OrderPriceSum' in value) || value['OrderPriceSum'] === undefined)
        return false;
    if (!('OrderPriceCurrency' in value) || value['OrderPriceCurrency'] === undefined)
        return false;
    if (!('OrderLocalizedPrice' in value) || value['OrderLocalizedPrice'] === undefined)
        return false;
    if (!('Compact' in value) || value['Compact'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreGetPiFormDataResponseFromJSON(json) {
    return FxIdWebFeaturesStoreGetPiFormDataResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPiFormDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'OrderPublicId': json['OrderPublicId'],
        'RedirectUrl': json['RedirectUrl'],
        'ProductName': json['ProductName'],
        'ProductDescription': json['ProductDescription'],
        'Sku': json['Sku'],
        'ImageUrl': json['ImageUrl'],
        'IconUrl': json['IconUrl'],
        'OrderPriceSum': json['OrderPriceSum'],
        'OrderPriceCurrency': json['OrderPriceCurrency'],
        'OrderLocalizedPrice': json['OrderLocalizedPrice'],
        'EmailPlaceholder': json['EmailPlaceholder'] == null ? undefined : json['EmailPlaceholder'],
        'PhonePlaceholder': json['PhonePlaceholder'] == null ? undefined : json['PhonePlaceholder'],
        'Compact': json['Compact'],
    };
}
export function FxIdWebFeaturesStoreGetPiFormDataResponseToJSON(json) {
    return FxIdWebFeaturesStoreGetPiFormDataResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPiFormDataResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'OrderPublicId': value['OrderPublicId'],
        'RedirectUrl': value['RedirectUrl'],
        'ProductName': value['ProductName'],
        'ProductDescription': value['ProductDescription'],
        'Sku': value['Sku'],
        'ImageUrl': value['ImageUrl'],
        'IconUrl': value['IconUrl'],
        'OrderPriceSum': value['OrderPriceSum'],
        'OrderPriceCurrency': value['OrderPriceCurrency'],
        'OrderLocalizedPrice': value['OrderLocalizedPrice'],
        'EmailPlaceholder': value['EmailPlaceholder'],
        'PhonePlaceholder': value['PhonePlaceholder'],
        'Compact': value['Compact'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreGetPiFormDataResponse.js.map